<template>
    <div>
        <app-nav />
        <main>
            <section>
                <div class="container wow fadeIn">
                    <validation-observer v-slot="{ validate }" slim>
                        <form @submit.prevent="store(validate)">
                            <!--dates-->
                            <section class="card shadow-none wow fadeIn" id="bron">
                                <div class="card-body m-0 py-0">
                                    <div v-if="page_loading" class="row top-m-p">
                                        <div class="col">
                                            <app-loader-svg />
                                        </div>
                                    </div>
                                    <div v-else class="row top-m-p">
                                        <!--vehicle info-->
                                        <div class="col-lg-4 col-md-12 mb-4 p-0">
                                            <div class="card">
                                                <div class="view overlay">
                                                    <template v-if="vehicle.imgs.length">
                                                        <vue-carousel :data="getVehicleImgs(vehicle.imgs)" :controls="false" indicator-type="disc" :indicators="vehicle.imgs.length === 1 ? false : true"/>
                                                    </template>
                                                    <img v-else src="~@assets/img/autod/1560423117.jpg" class="card-img-top" alt=""/>
                                                </div>
                                                <div class="card-body">
                                                    <div class="pl-3 m-0 pt-2">
                                                        <h5 class="card-title dark-grey-text font-weight-normal">
                                                            {{ vehicle.make.name }} {{ vehicle.model.name }} <app-vehicle-no :slug="vehicle.slug"/>
                                                        </h5>
                                                        <p class="dark-grey-text p-300">
                                                            {{ $t(vehicle.transmission.name) }}, {{ $t(vehicle.fuel.name) }} <br>
                                                            {{ $t('Year') }}: {{ vehicle.user_year }} <br>
                                                            {{ $t('Engine') }}: {{ vehicle.engine }} <br>
                                                            {{ $t('Color') }}: {{ vehicle.color[locale] }} <br>
                                                            {{ $t('Body type') }}: {{ vehicle.body_type[locale] }}
                                                        </p>
                                                        <p class="dark-grey-text p-300">
                                                            {{ $t('Equipment') }}: <br>
                                                            {{ vehicle.equipment[locale] }}
                                                        </p>
                                                    </div>
                                                    <hr>
                                                    <div>
                                                        <router-link to="/" class="dark-grey-text p-300-xs">
                                                            <fa-icon :icon="['fas', 'angle-left']" class="mr-1" />
                                                            {{ $t('back to search') }}
                                                        </router-link>
                                                    </div>
                                                    <hr>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-lg-8 col-md-12">
                                            <div class="row">
                                                <!--dates & locations-->
                                                <div class="col-lg-6 col-md-6 col-sm-12 mb-4 pl-4">
                                                    <app-overlapping :vehicle="vehicle"/>
                                                    <app-datepicker id="search_dates"
                                                                    v-model="search_dates"
                                                                    range
                                                                    disabledBeforeToday
                                                                    name="search_dates"
                                                                    @change="refreshData"
                                                                    class="mb-1"
                                                                    rules="required">
                                                        <template #label>
                                                            {{ $t('Start date') }} & {{ $t('Return date') }}*
                                                        </template>
                                                    </app-datepicker>
                                                    <div class="row">
                                                        <div class="col">
                                                            <app-datepicker id="start_time"
                                                                            v-model="start_time"
                                                                            inputType="time"
                                                                            name="start_time"
                                                                            @change="refreshData"
                                                                            class="mb-1"
                                                                            rules="required">
                                                                <template #label>
                                                                    {{ $t('Start time') }}*
                                                                </template>
                                                            </app-datepicker>
                                                        </div>
                                                        <div class="col">
                                                            <app-datepicker id="end_time"
                                                                            v-model="end_time"
                                                                            inputType="time"
                                                                            name="end_time"
                                                                            @change="refreshData"
                                                                            class="mb-1"
                                                                            rules="required">
                                                                <template #label>
                                                                    {{ $t('Return time') }}*
                                                                </template>
                                                            </app-datepicker>
                                                        </div>
                                                    </div>
                                                    <app-select
                                                        id="pickup_location_id"
                                                        v-model="form.pickup_location_id"
                                                        :options="locations.map(c => c.id)"
                                                        rules="required"
                                                        name="pickup_location_id"
                                                        openDirection="bottom"
                                                        class="mb-1"
                                                        searchable
                                                        not-empty
                                                        closeOnSelect
                                                        @input="checkPaidServices"
                                                        :custom-label="
                                                            id =>
                                                                locations.some(c => c.id === id)
                                                                    ? locations.find(c => c.id === id).name[locale]
                                                                    : null
                                                        ">
                                                        <template #label>
                                                            {{ $t('Pick up from') }}*
                                                        </template>
                                                    </app-select>
                                                    <app-input v-if="form.pickup_location_id === otherLocationId"
                                                               id="pickup_location"
                                                               v-model="form.pickup_location_custom"
                                                               :placeholder="`${$t('Address')}*`"
                                                               @blur="checkPaidServices"
                                                               name="pickup_location"
                                                               rules="required" />
                                                    <app-select
                                                        id="return_location_id"
                                                        v-model="form.return_location_id"
                                                        :options="locations.map(c => c.id)"
                                                        rules="required"
                                                        name="return_location_id"
                                                        openDirection="bottom"
                                                        class="mb-1"
                                                        searchable
                                                        not-empty
                                                        closeOnSelect
                                                        @input="checkPaidServices"
                                                        :custom-label="id => locations.some(c => c.id === id) ? locations.find(c => c.id === id).name[locale] : null">
                                                        <template #label>
                                                            {{ $t('Return to') }}*
                                                        </template>
                                                    </app-select>
                                                    <app-input v-if="form.return_location_id === otherLocationId"
                                                               id="return_location"
                                                               v-model="form.return_location_custom"
                                                               :placeholder="`${$t('Address')}*`"
                                                               @blur="checkPaidServices"
                                                               name="return_location"
                                                               rules="required" />
                                                    <hr>
                                                    <!--calendar-->
                                                    <app-booking-calendar :id="form.vehicle_id" :dates_chosen="[searchDates[0], searchDates[1]]" :booked_dates="vehicle.booked_dates" :unconfirmed_dates="vehicle.unconfirmed_dates"/>
                                                </div>
                                                <div class="col-lg-6 col-md-6 col-sm-12 m-0">
                                                    <booking-details
                                                        :promocode_id="form.promocode_id"
                                                        :totalServPrice="totalServPrice"
                                                        :totalPrice="totalPrice"
                                                        :rentPrice="rentPrice"
                                                        :totalAddEqPrice="totalAddEqPrice"
                                                        :totalAddEqAddedPrice="totalAddEqAddedPrice"
                                                        :discountFromFullPrice="discountFromFullPrice"
                                                        :discount="discount"
                                                        :vehicle="vehicle"
                                                        :additional_eqs="additional_eqs"
                                                        :paid_services="paid_services"
                                                        :search_dates="search_dates"
                                                        :start_time="start_time"
                                                        :end_time="end_time"
                                                        :pickup_location_id="form.pickup_location_id"
                                                        :return_location_id="form.return_location_id"
                                                        :locations="locations"/>
                                                    <div class="card p-2">
                                                        <app-input id="promocode" v-model="promocode" name="promocode" :placeholder="$t('Enter promocode')" @blur="checkPromo">
                                                            <template #input-append>
                                                                <button class="btn btn-info btn-md waves-effect m-0" type="button" @click="checkPromo" :disabled="promocode === null">
                                                                    {{ $t('Add') }}
                                                                </button>
                                                            </template>
                                                        </app-input>
                                                    </div>
                                                    <div class="mt-4">
                                                        <ul class="list-group">
                                                            <li class="list-group-item py-0 px-3">
                                                                <div class="md-v-line ">
                                                                    <p class="dark-grey-text p-300-xs">
                                                                        <img height="15px" src="~@assets/img/svg/kalender/marker.svg" alt=""/> {{ $t('Available') }}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                            <li class="list-group-item py-0 px-3">
                                                                <div class="md-v-line">
                                                                    <p class="dark-grey-text p-300-xs">
                                                                        <img height="15px" src="~@assets/img/svg/kalender/marker_info.svg" alt=""/> {{ $t('Unconfirmed') }}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                            <li class="list-group-item py-0 px-3">
                                                                <div class="md-v-line">
                                                                    <p class="dark-grey-text p-300-xs">
                                                                        <img height="15px" src="~@assets/img/svg/kalender/marker_secondary.svg" alt=""/> {{ $t('Booked') }}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                            <li class="list-group-item py-0 px-3">
                                                                <div class="md-v-line">
                                                                    <p class="dark-grey-text p-300-xs">
                                                                        <img height="15px" src="~@assets/img/svg/kalender/marker_primary.svg" alt=""/> {{ $t('My dates') }}
                                                                    </p>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div class="col-md-12 col-sm-12">
                                            <div class="mt-2 mb-3">
                                                <ul class="nav nav-tabs justify-content-center">
                                                    <li class="nav-item mb-0">
                                                        <a class="nav-link active text-center" data-toggle="tab" href="#active_pl">
                                                            {{ JSON.parse(pricelist[0].name)[locale] }} <br>
                                                            <small>{{ validityPeriod(pricelist[0]) }}</small>
                                                        </a>
                                                    </li>
                                                    <li class="nav-item mb-0">
                                                        <a class="nav-link text-center" data-toggle="tab" href="#inactive_pl">
                                                            {{ JSON.parse(inactive_pl[0].name)[locale] }} <br>
                                                            <small>{{ validityPeriod(inactive_pl[0]) }}</small>
                                                        </a>
                                                    </li>
                                                </ul>
                                                <div class="tab-content">
                                                    <div class="tab-pane container active" id="active_pl">
                                                        <pricelist-table :pricelist="pricelist" :vehicle="vehicle" />
                                                        <p>
                                                            {{ $t('All prices include VAT') }}
                                                        </p>
                                                    </div>
                                                    <div class="tab-pane container fade" id="inactive_pl">
                                                        <pricelist-table :pricelist="inactive_pl" :vehicle="vehicle" />
                                                        <p>
                                                            {{ $t('All prices include VAT') }}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!--hr-->
                                    <div v-if="!page_loading" class="row">
                                        <div class="col">
                                            <hr class="mt-0" />
                                            <div class=" pl-3">
                                                <p class="dark-grey-text p-300-sm ">
                                                    {{ $t('Check your dates') }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <!--add eq-->
                            <section v-if="!page_loading">
                                <div class="row justify-content-between wow fadeIn">
                                    <div class="col mb-4">
                                        <div class="accordion" id="accordionL-varustus">
                                            <div class="card shadow-none">
                                                <div class="card-header pointer" data-toggle="collapse" href="#additional_equipment">
                                                    <a class="card-link font-weight-normal pl-1">
                                                        {{ $t('Add additional equipment') }}
                                                        <fa-icon :icon="['fas', 'angle-down']" pull="right" />
                                                    </a>
                                                </div>
                                                <div id="additional_equipment" class="collapse" aria-labelledby="headingL-varustus" data-parent="#accordionL-varustus">
                                                    <div class="card-body">
                                                        <app-loader-gif v-if="loading" />
                                                        <div v-else class="row wow fadeIn">
                                                            <div v-for="(add_eqs, i) in add_eq_arr" class="col-lg-4 m-0" :key="i">
                                                                <ul class="list-group">
                                                                    <li v-for="(eq, j) in add_eqs" class="list-group-item p-0" :key="j">
                                                                        <app-custom-checkbox :id="`eq_${i}_${j}`"
                                                                                             :name="`eq_${i}_${j}`"
                                                                                             @input="addAddEq(eq)">
                                                                            {{ $t(eq.name[locale]) }}
                                                                            <small>({{ ((eq.all_prices.price + eq.all_prices.added_price) / 100).toFixed(2) }} EUR)</small>
                                                                        </app-custom-checkbox>
                                                                    </li>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <!--form-->
                            <section v-if="!page_loading">
                                <div class="container mt-3 pt-2 wow fadeIn">
                                    <div class="row justify-content-center wow fadeIn">
                                        <div class="col text-center">
                                            <h2 class="dark-grey-text font-weight-normal mb-5">
                                                {{ $t('Vehicle booking') }}
                                            </h2>
                                        </div>
                                    </div>
                                    <div class="row mb-5 pb-5">
                                        <div class="col-md-5 col-lg-4 mb-4">
                                            <booking-details
                                                :promocode_id="form.promocode_id"
                                                :totalServPrice="totalServPrice"
                                                :totalPrice="totalPrice"
                                                :rentPrice="rentPrice"
                                                :totalAddEqPrice="totalAddEqPrice"
                                                :totalAddEqAddedPrice="totalAddEqAddedPrice"
                                                :discountFromFullPrice="discountFromFullPrice"
                                                :discount="discount"
                                                :vehicle="vehicle"
                                                :additional_eqs="additional_eqs"
                                                :paid_services="paid_services"
                                                :search_dates="search_dates"
                                                :start_time="start_time"
                                                :end_time="end_time"
                                                :pickup_location_id="form.pickup_location_id"
                                                :return_location_id="form.return_location_id"
                                                :locations="locations"/>
                                        </div>
                                        <div class="col-md-7 col-lg-8 mb-4">
                                            <div class="card">
                                                <div class="card-body">
                                                    <div class="row">
                                                        <div class="col-md-6 mb-2">
                                                            <app-input
                                                                id="firstName"
                                                                v-model="form.fname"
                                                                name="firstName"
                                                                rules="required"
                                                                noCustomBg
                                                                mdForm>
                                                                <template #label> {{ $t('First name') }}* </template>
                                                            </app-input>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <app-input
                                                                id="lastName"
                                                                v-model="form.lname"
                                                                name="lastName"
                                                                rules="required"
                                                                noCustomBg
                                                                mdForm>
                                                                <template #label> {{ $t('Last name') }}* </template>
                                                            </app-input>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-md-6 mb-2">
                                                            <app-input
                                                                id="phone"
                                                                type="tel"
                                                                v-model="form.phone"
                                                                name="phone"
                                                                rules="required"
                                                                noCustomBg
                                                                @blur="checkClientDiscount"
                                                                mdForm>
                                                                <template #label> {{ $t('Phone') }}* </template>
                                                            </app-input>
                                                        </div>
                                                        <div class="col-md-6 mb-2">
                                                            <app-input
                                                                id="email"
                                                                v-model="form.email"
                                                                name="email"
                                                                rules="required"
                                                                noCustomBg
                                                                @blur="checkClientDiscount"
                                                                mdForm>
                                                                <template #label> {{ $t('Email') }}* </template>
                                                            </app-input>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="col-lg-6 mb-4">
                                                            <app-textarea id="comments" v-model="form.comments" name="comments" noCustomBg :rows="7">
                                                                <template #label>
                                                                    {{ $t('Extra info') }}
                                                                </template>
                                                            </app-textarea>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 mb-4">
                                                            <app-select
                                                                id="lang"
                                                                v-model="form.lang"
                                                                :options="langs.map(l => l.key)"
                                                                name="lang"
                                                                openDirection="bottom"
                                                                searchable
                                                                not-empty
                                                                noCustomBg
                                                                closeOnSelect
                                                                :custom-label="
                                                                    key =>
                                                                        langs.some(l => l.key === key)
                                                                            ? $t(langs.find(l => l.key === key).name)
                                                                            : null
                                                                ">
                                                                <template #label>
                                                                    {{ $t('Language of communication') }}*
                                                                </template>
                                                            </app-select>
                                                            <div class="mt-4"></div>
                                                            <app-custom-checkbox id="travel_out_check" v-model="travel_out_check" name="travel_out_check">
                                                                {{ $t('Travel out of Estonia') }}
                                                            </app-custom-checkbox>
                                                            <app-input
                                                                v-if="travel_out_check"
                                                                id="travel_out"
                                                                v-model="form.travel_out"
                                                                name="travel_out"
                                                                rules="required"
                                                                noCustomBg
                                                                mdForm>
                                                                <template #label> {{ $t('Countries') }}*</template>
                                                            </app-input>
                                                        </div>
                                                    </div>
                                                    <hr />
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 mb-4">
                                                            <app-custom-checkbox id="tos" v-model="form.tos" name="tos">
                                                                {{ $t('I accept terms') }}
                                                            </app-custom-checkbox>
                                                            <app-custom-checkbox id="newsletter" v-model="form.newsletter" name="newsletter">
                                                                {{ $t('Send me newsletters') }}
                                                            </app-custom-checkbox>
                                                        </div>
                                                        <div class="col-lg-6 col-md-6 mb-4 pt-1">
                                                            <div class="text-right dark-grey-text p-300 pr-3">
                                                                <a role="button" @click="$modal.show('terms')">
                                                                    {{ $t('Rental terms') }}
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <hr class="mb-4" />
                                                    <app-button
                                                        class="btn btn-autorent waves-effect waves-light btn-lg btn-block"
                                                        :loading="start_booking"
                                                        :disabled="form.tos === false">
                                                        {{ $t('Confirm booking') | toUpper }}
                                                    </app-button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </form>
                    </validation-observer>
                </div>
            </section>
        </main>
        <app-footer />
        <terms-modal @acceptTerms="acceptTerms" />
    </div>
</template>

<script>
import AppNav from '@components/layout/public/Nav';
import AppFooter from '@components/layout/public/Footer';
import PublicSettingsService from '@services/publicSettings.service';
import PublicBookingService from '@services/publicBooking.service';
import AppBookingCalendar from '@components/layout/public/BookingCalendar';
import PricelistTable from './components/PricelistTable';
import BookingDetails from './components/BookingDetails';
import {mapGetters} from 'vuex';
import chunk from 'lodash/chunk';
import TermsModal from './modals/Terms';
import moment from 'moment';
import Vue from 'vue';
import {eventBus} from '@/main';
import { validityPeriod } from '@services/helper.service';

export default {
    data() {
        return {
            search_dates: [this.$route.query.start_date, this.$route.query.end_date],
            start_time: '',
            end_time: '',
            travel_out_check: false,
            form: {
                start_date: null,
                end_date: null,
                start_time: null,
                end_time: null,
                vehicle_id: null,
                client_id: null,
                offer_id: null,
                pickup_location_id: 1,
                return_location_id: 1,
                pickup_location_custom: '',
                return_location_custom: '',
                promocode_id: null,
                fname: null,
                lname: null,
                phone: null,
                email: null,
                comments: null,
                additional_eq: [],
                services: [],
                lang: null,
                travel_out: null,
                tos: false,
                newsletter: false
            },
            promocode: null,
            discount: 0,
            // discount_from_full_price: false,
            loading: false,
            page_loading: false,
            start_booking: false,
            pricelist: [],
            inactive_pl: [],
            locations: [],
            paid_services: [],
            add_eq_arr: [],
            additional_eqs: [],
            vehicle: {
                overlapping: {
                    start: null,
                    end: null
                },
                make: {},
                model: {},
                transmission: {},
                fuel: {},
                color: {},
                imgs: []
            }
        };
    },
    watch: {
        promocode(val) {
            if (!val) {
                this.form.promocode_id = null;
                this.discount = 0;
                this.checkClientDiscount();
            }
        }
    },
    computed: {
        ...mapGetters(['envUrl', 'locale', 'langs', 'localeDateFormat', 'otherLocationId']),
        searchDates() {
            return this.search_dates;
        },
        rentPrice() {
            if (!this.start_time || !this.end_time) {
                return 0;
            }
            // if (this.vehicle.all_prices.has_discount) {
            //     return this.vehicle.all_prices.discount_price + this.vehicle.all_prices.added_price;
            // }
            return this.vehicle.all_prices.price + this.vehicle.all_prices.added_price;
        },
        discountFromFullPrice() {
            let res = false;
            if (this.vehicle.all_prices.has_discount) {
                let price = this.vehicle.all_prices.full_price;
                if(this.discount > 0) {
                    price = price * (100 - this.discount) / 100;
                }
                if (this.vehicle.all_prices.discount_price > price) {
                    res = true;
                }
            } else {
                if(this.discount > 0) {
                    res = true;
                }
            }

            return res;
        },
        totalPrice() {
            if (!this.start_time || !this.end_time) {
                return 0;
            }
            return this.vehicle.all_prices.price + this.vehicle.all_prices.added_price + this.totalServPrice + this.totalAddEqPrice + this.totalAddEqAddedPrice;
            // let addedPrices = this.totalServPrice + this.totalAddEqPrice + this.totalAddEqAddedPrice;
            // let price = this.vehicle.all_prices.price;
            // let discountPrice = this.vehicle.all_prices.discount_price;
            // let total = 0;
            // // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            // this.discount_from_full_price = false;
            //
            // if (this.vehicle.all_prices.has_discount) {
            //     total = discountPrice;
            //     if(this.discount > 0) {
            //         price = (price - price * (this.discount / 100));
            //     }
            //     if (discountPrice > price) {
            //         // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            //         this.discount_from_full_price = true;
            //         total = price;
            //     }
            // } else {
            //     total = price;
            //     if(this.discount > 0) {
            //         // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            //         this.discount_from_full_price = true;
            //         total = (total - total * (this.discount / 100));
            //     }
            // }
            //
            // return total + this.vehicle.all_prices.added_price + this.totalServPrice + this.totalAddEqPrice + this.totalAddEqAddedPrice;
        },
        totalAddEqPrice() {
            let total = 0;
            this.additional_eqs.map(eq => {
                total += eq.all_prices.price;
            });

            return total;
        },
        totalAddEqAddedPrice() {
            let total = 0;
            this.additional_eqs.map(eq => {
                total += eq.all_prices.added_price;
            });

            return total;
        },
        totalServPrice() {
            let total = 0;
            this.paid_services.map(serv => {
                total += serv.price;
            });

            return total;
        }
    },
    methods: {
        getVehicleImgs(imgs) {
            return imgs.map(i => `<img src="${this.envUrl}/vehicles/${i.dbname}" height="auto" class="card-img-top"/>`);
        },
        validityPeriod(pricelist) {
            return validityPeriod(pricelist);
        },
        refreshData() {
            if (this.start_time && this.end_time) {
                this.getVehicle();
            }
            this.getAddEq();
            this.checkPaidServices();
        },
        addAddEq(eq) {
            const index = this.additional_eqs.indexOf(eq);
            if (index > -1) {
                this.additional_eqs.splice(index, 1);
            } else {
                this.additional_eqs.push(eq);
            }
        },
        locationName(locationId) {
            return this.locations.some(l => l.id === locationId)
                ? this.locations.find(l => l.id === locationId).name[this.locale]
                : null;
        },
        checkIsVehicleBooked() {
            if (!this.search_dates) {
                return false;
            }
            eventBus.$emit('changeChosenDates', {dates: this.search_dates, times: [this.start_time, this.end_time]});

            if (!this.start_time || !this.end_time || !this.form.vehicle_id) {
                return false;
            }
            const queryObj = {
                start_date: this.search_dates[0],
                end_date: this.search_dates[1],
                start_time: this.start_time,
                end_time: this.end_time,
                vehicle_id: this.form.vehicle_id,
            };

            PublicBookingService.checkIsVehicleBooked(queryObj);
        },
        checkPaidServices() {
            this.checkIsVehicleBooked();
            if (!this.start_time || !this.end_time || !this.search_dates || !this.form.pickup_location_id || !this.form.return_location_id || !this.form.vehicle_id) {
                return false;
            }
            const queryObj = {
                start_date: this.search_dates[0],
                end_date: this.search_dates[1],
                start_time: this.start_time,
                end_time: this.end_time,
                pickup_location_id: this.form.pickup_location_id,
                pickup_custom: this.form.pickup_location_id === this.otherLocationId ? 1 : 0,
                return_location_id: this.form.return_location_id,
                return_custom: this.form.return_location_id === this.otherLocationId ? 1 : 0,
            };

            PublicBookingService.checkPaidServices(this.form.vehicle_id, queryObj).then(res => {
                this.paid_services = res;
            });
        },
        checkPromo() {
            if (this.form.offer_id) {
                return false;
            }
            if (!this.search_dates.length) {
                return false;
            }
            const queryObj = {
                code: this.promocode,
                start_date: this.search_dates[0],
                end_date: this.search_dates[1]
            };
            PublicBookingService.checkPromocode(queryObj).then(res => {
                if (res) {
                    this.discount = res.discount;
                    this.form.promocode_id = res.id;
                    this.form.client_id = null;
                } else {
                    this.discount = 0;
                    this.form.promocode_id = null;
                }
                this.getVehicle();
            });
        },
        checkClientDiscount() {
            if (this.form.offer_id) {
                return false;
            }
            const queryObj = {
                phone: this.form.phone,
                email: this.form.email
            };
            PublicBookingService.checkClientDiscount(queryObj).then(res => {
                if (res) {
                    this.discount = res.discount;
                    this.form.client_id = res.id;
                    this.form.promocode_id = null;
                    this.getVehicle();
                } else {
                    this.discount = 0;
                    this.form.client_id = null;
                    this.checkPromo();
                }
            });
        },
        checkOffer(offer, vehicleId) {
            const queryObj = {
                slug: offer,
                vehicle_id: vehicleId
            };
            PublicBookingService.checkOffer(queryObj).then(res => {
                if (res) {
                    this.form.offer_id = res.id;
                    this.discount = res.discount;
                    this.form.promocode_id = null;
                    this.form.client_id = null;
                    this.getVehicle();
                }
            });
        },
        store(validate) {
            validate().then(valid => {
                if (valid) {
                    this.start_booking = true;
                    this.form.additional_eq = this.additional_eqs.length ? this.additional_eqs : [];
                    this.form.start_date = this.search_dates[0];
                    this.form.end_date = this.search_dates[1];
                    this.form.start_time = this.start_time;
                    this.form.end_time = this.end_time;
                    this.form.pickup_custom = this.form.pickup_location_id === this.otherLocationId ? 1 : 0,
                    this.form.return_custom = this.form.return_location_id === this.otherLocationId ? 1 : 0,

                    PublicBookingService.store(this.form).then(res => {
                        this.start_booking = false;
                        if (res) {
                            this.$router.push({ name: 'pub.booking.success' });
                        }
                    }).catch(e => {
                        console.log(e);
                        this.start_booking = false;
                    });
                }
            });
        },
        acceptTerms() {
            this.form.tos = true;
        },
        getLocations() {
            PublicSettingsService.locations().then(res => (this.locations = res));
        },
        getAddEq() {
            this.loading = true;
            this.additional_eqs = [];
            PublicSettingsService.addEq(this.composeQueryObj()).then(res => {
                this.add_eq_arr = chunk(res, 3);
                this.loading = false;
            });
        },
        getVehicle() {
            PublicBookingService.getVehicle(this.composeQueryObj()).then(res => {
                this.vehicle = res.vehicle;
                this.pricelist = res.pricelist;
                this.inactive_pl = res.inactive_pl;
                this.form.vehicle_id = res.vehicle.id;
                if (this.$route.query.offer) {
                    this.checkOffer(this.$route.query.offer, res.vehicle.id);
                }
                this.page_loading = false;
            });
        },
        composeQueryObj() {
            const queryObj = {
                slug: this.$route.params.vehicle_slug,
                start_date: this.search_dates[0],
                end_date: this.search_dates[1],
                discount: this.discount,
                additional_eq: this.additional_eqs.length ? this.additional_eqs.map(eq => eq.id) : [],
                pickup_custom: this.form.pickup_location_id === this.otherLocationId ? 1 : 0,
                return_custom: this.form.return_location_id === this.otherLocationId ? 1 : 0,
                pickup_location_id: this.form.pickup_location_id,
                return_location_id: this.form.return_location_id,

            };
            if(this.start_time) {
                queryObj.start_time = this.start_time;
            }
            if(this.end_time) {
                queryObj.end_time = this.end_time;
            }

            return queryObj;
        },
        setDates() {
            this.page_loading = true;
            const start = this.$route.query.start_date || moment(new Date).format(this.localeDateFormat);
            const end = this.$route.query.end_date || moment(new Date).add(1, 'day').format(this.localeDateFormat);
            this.search_dates = [start, end];
            this.form.lang = this.locale;
            this.getLocations();
            this.getAddEq();
            this.getVehicle();
        }
    },
    components: {
        AppNav,
        AppFooter,
        TermsModal,
        AppBookingCalendar,
        PricelistTable,
        BookingDetails
    },
    created() {
        this.setDates();
    },
    metaInfo() {
        return {
            title: `${this.$t('Booking')} | Autorent OÜ`
        };
    }
};
</script>
